import { Icon } from "@resource/atlas";
import {
  atlasCircleChecked,
  atlasCircleDot,
  atlasCircleLock,
} from "@resource/atlas/icons";
import clsx from "clsx";

const CURRENT_ICON = atlasCircleDot;
const LOCKED_ICON = atlasCircleLock;
const AVAILABLE_ICON = atlasCircleChecked;

type StepIndicatorProps = {
  isCurrent: boolean;
  isLocked: boolean;
};

function StepIndicator({ isCurrent, isLocked }: StepIndicatorProps) {
  function getIcon() {
    if (isCurrent) return CURRENT_ICON;
    if (isLocked) return LOCKED_ICON;
    return AVAILABLE_ICON;
  }

  return (
    <div
      className={clsx(
        "relative w-5 h-5 flex-shrink-0",
        isLocked ? "text-org-primary-light" : "text-org-primary"
      )}
    >
      {/* this div is the background for the icon... yep, hacky, but it works */}
      <div
        className={clsx(
          "absolute rounded-full top-1 left-1 w-3 h-3",
          isLocked ? "bg-org-primary" : "bg-white"
        )}
      />
      <Icon className="absolute inset-0" content={getIcon()} />
    </div>
  );
}

export default StepIndicator;
